import PropTypes from 'prop-types';
import SiblingButton from './siblingButton';
import Icon from '../icon';

export default function Previous({ stackOrder, adobeContentType, ...otherProps }) {
  return (
    <SiblingButton
      siblingType="Previous"
      iconPlacement="left"
      icon={Icon.NavigateLeft}
      id={`${stackOrder}-prev-btn`}
      adobeContentType={adobeContentType}
      navigationNameEventData={`previous-${adobeContentType || 'article'}`}
      {...otherProps}
    />
  );
}

Previous.propTypes = {
  stackOrder: PropTypes.string.isRequired,
  adobeContentType: PropTypes.string,
};

Previous.defaultProps = {
  adobeContentType: undefined,
};
